import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

//API
import api from "../../../../../api/api";

//Components
import Spinner from "../../../../layout/Spinner";
import FinishRecipeSection from "./FinishRecipeSection";

import Typography from "@mui/material/Typography";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";

//Actions
import { setAlert } from "../../../../../actions/alert";

const FinishRecipeModal = ({ walkthrough: { recipe }, setAlert }) => {
  const navigate = useNavigate();

  const [loadingCookable, setLoadingCookable] = useState(true);
  const [cookableSections, setCookableSections] = useState([]);

  const setCookableChecked = (index, value) => {
    let newSections = [...cookableSections];
    newSections[index].cooked = value;
    setCookableSections(newSections);
  };
  const getCookableSections = () => {
    let sections = [];

    for (let [index, section] of recipe.sections.entries()) {
      console.log(section, index);
      if (section?.ingredients?.length > 0 || section?.macros?.length > 0) {
        sections.push({
          index: index,
          title: section.title,
          cooked: true,
          showIngredients: false,
          sectionData: section,
        });
      }
    }

    setCookableSections(sections);
    setLoadingCookable(false);
  };

  const handleSubmit = async () => {
    //Send cooked data to DB

    try {
      const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      let hasOneCooked = false;
      for (let section of cookableSections) {
        if (section.cooked) {
          hasOneCooked = true;
          break;
        }
      }

      if (!hasOneCooked) {
        setAlert(`Please select at least one section that you cooked`, "error");
        return;
      }

      const res = await api.post("/pantry/cook", {
        recipeId: recipe._id,
        sections: cookableSections,
        timezone: userTimezone,
      });

      setAlert(`Cooked ${recipe.name}`, "success");
      //Redirect to cookbook
      navigate("/cookbook");
      //Reset walkthrough state
    } catch (error) {
      setAlert(`Error finishing ${recipe.name}. Please refresh the page and try again`, "error");
    }
  };

  useEffect(() => {
    getCookableSections();
  }, []);

  //TO DO:
  //Display sections with ingredients
  //Handle "used" state
  //Handle "finish" button click

  return (
    <div>
      {loadingCookable ? (
        <Spinner />
      ) : (
        <>
          <div className="p-4 bg-neutral-100">
            <Typography variant="h6" className="font-normal">
              Which sections did you make?
            </Typography>
          </div>
          <div>
            {cookableSections.map((section, i) => (
              <FinishRecipeSection
                section={recipe.sections[section.index]}
                sectionIndex={section.index}
                checked={cookableSections[i].cooked}
                setChecked={setCookableChecked}
                key={`cooksection-${i}`}
              />
            ))}
          </div>
          <div className="w-full flex justify-end p-4">
            <Button variant="contained" color="primary" disableElevation onClick={() => handleSubmit()} fullWidth>
              Finish Recipe
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

FinishRecipeModal.propTypes = {
  walkthrough: PropTypes.object.isRequired,
  setAlert: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  walkthrough: state.walkthrough,
});

export default connect(mapStateToProps, { setAlert })(FinishRecipeModal);
